<script lang="ts">
  // components
  import ReactivationPaymentSettingsBanner from "@retailer/svelte/Payments/Banners/ReactivationPaymentSettings.svelte";
  import DisabledBanner from "@retailer/svelte/Payments/Banners/Disabled.svelte";

  // stores
  import { userDisabled, userReactivated } from "@retailer/svelte/stores/DwollaIdentityStore";

</script>

{#if $userDisabled}
  <DisabledBanner />
{:else if $userReactivated}
  <ReactivationPaymentSettingsBanner />
{/if}
